type PfCalculationParams = {
    providentFundType: "mandatory" | "voluntary";
    employeeSharePercent: number;
    organizationSharePercent: number;
    selectedEarnings: { id: number; amount: number }[];
};

type PfCalculationResult = {
    employeeShareAmount: number;
    organizationShareAmount: number;
};

export function calculatePfAmounts({
    providentFundType,
    employeeSharePercent,
    organizationSharePercent,
    selectedEarnings
}: PfCalculationParams): PfCalculationResult {
    const totalEarningAmount = selectedEarnings.reduce((sum, earning) => sum + earning.amount, 0);
    const cappedEarning = totalEarningAmount > 15000 ? 15000 : totalEarningAmount;

    if (providentFundType === "mandatory") {
        return {
            employeeShareAmount: (employeeSharePercent / 100) * cappedEarning,
            organizationShareAmount: (organizationSharePercent / 100) * cappedEarning
        };
    }

    // ✅ Voluntary PF logic:
    return {
        employeeShareAmount: (employeeSharePercent / 100) * totalEarningAmount, // full amount
        organizationShareAmount: (organizationSharePercent / 100) * cappedEarning // still capped
    };
}

